var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M10.9866 9.07248C14.6361 2.35406 20.6079 -0.0789385 23.1792 2.51996C27.4369 6.66713 21.2052 14.0491 10.9866 9.07248ZM10.9866 9.07248C-1.78673 2.85172 -0.353264 11.6485 4.5355 11.6485C10.535 11.6485 10.9866 9.07248 10.9866 9.07248ZM10.9866 9.07248L11.0355 27.6485M10.9866 9.07248C14.5531 23.5046 25.4809 19.1267 20.5355 17.1485C18.0355 16.1485 22.7564 27.8177 18.0355 27.6485C15.748 27.5665 18.5355 24.1485 19.0355 27.1485",
    stroke: "#FAFAFA",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c41907ad3a9e204f45f676fa6a1c5e66.svg";
export { ForwardRef as ReactComponent };